const state = {
  unfilledFields: 0,
  incompleteGuests: 0,
};

const mutations = {
  SET_UNFILLED_FIELDS(state, number) {
    state.unfilledFields = number;
  },

  SET_INCOMPLETE_GUESTS(state, number) {
    state.incompleteGuests = number;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
